import { PlanningsDeliveryWithLegRunEntity } from 'src/entities/PlanningsDelivery.entity';

/** ISO 形式 / Date 文字列を "HH:mm" に整形する。失敗時は null。 */
function formatHourMinute(value: string | undefined | null): string | null {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

export type ShiftTimeEntry = {
  /** 当日の勤務開始時刻 (HH:mm)。delivery.startAt 由来。 */
  start: string | null;
  /** 当日の勤務終了時刻 (HH:mm)。delivery.endAt 由来。 */
  end: string | null;
  /** 労働可能時間 (秒)。delivery.workingAvailableDurationSeconds 由来。 */
  workingAvailableSeconds: number | null;
};

/**
 * truckId → 当日の勤務時刻と労働可能時間。
 *
 * 同じ truckId が複数 delivery を持つ場合は最初の delivery を代表値にする
 * (Presenter の shiftTruckByTruckId / truckDriverMap と同じ「最初に見つかった値」規則)。
 *
 * Presenter の useMemo から切り出した理由: Presenter を mount せずに
 * 「労働可能時間が deliveries から格納される」ことをテストできるようにするため。
 * /map 側の buildVehicleExtraMap.ts と同じ切り出し方に合わせている。
 */
export function buildShiftTimeByTruckId(
  deliveries: readonly PlanningsDeliveryWithLegRunEntity[],
): Map<number, ShiftTimeEntry> {
  const map = new Map<number, ShiftTimeEntry>();
  for (const d of deliveries) {
    if (map.has(d.truckId)) continue;
    map.set(d.truckId, {
      start: formatHourMinute(d.startAt),
      end: formatHourMinute(d.endAt),
      workingAvailableSeconds: d.workingAvailableDurationSeconds ?? null,
    });
  }
  return map;
}
